import React, {useState} from 'react';
import './TextInBoxService.scss';
import sample from "./Tire.png";
import SelectWorkerModal from "../../../CarWashFactor/SelectWorkerModal";

const TextInBoxService = ({servicesListWorkerModalHandler, ComponentData}) => {

    const [isOpenModal, setIsOpenModal] = useState(false);
    const [lastServiceIdClicked, setLastServiceIdClicked] = useState({});

    const serviceItemHandler = (initialServiceObject) => {
        console.log(initialServiceObject)
        setLastServiceIdClicked(initialServiceObject)
        setIsOpenModal(true);
    }
    const workerModalHandler = (v = []) => {
        console.log(v)
    };

    const inServiceListWorkerHandler = (arr) => {

        let temp = {...lastServiceIdClicked, workers: arr}

        setIsOpenModal(false)
        servicesListWorkerModalHandler(temp)
    }

    return (

        <>
            {isOpenModal ?
                    <SelectWorkerModal
                        workers={ComponentData?.workers}
                        workerModalHandler={workerModalHandler}
                        isOpen={isOpenModal}
                        modalCallback={(isOpenObject) => setIsOpenModal(isOpenObject.isOpen)}
                        servicesListWorkerModalHandler={inServiceListWorkerHandler}
                    /> : <></>}

            {ComponentData.services?.map((v, index) =>

                <div className={`text-box`}
                     onClick={() => serviceItemHandler(v)} key={index}>

                    <img src={sample} alt=""/>
                    <p>{v.title}</p>

                </div>
            )}

        </>
    );
};

export default TextInBoxService;